module.exports = __webpack_public_path__ + "static/media/speech_10.d3e86eba.png";